import { useAuth } from 'react-oidc-context';

import { useRoles } from '../auth/roles';
import { Button } from '../ui/button';

/** Top bar: signed-in identity, the user's roles, and logout (RP-initiated). */
export function TopBar() {
  const auth = useAuth();
  const roles = useRoles();
  const profile = auth.user?.profile;
  const name = profile?.preferred_username ?? profile?.name ?? profile?.sub ?? 'admin';

  return (
    <header className="flex items-center gap-3 h-10 px-4 bg-chrome text-chrome-fg shrink-0">
      <span className="font-semibold text-base">Gigantica Admin</span>
      <span className="ml-auto text-sm text-chrome-fg-dim">
        {name} · <em>{roles.length ? roles.join(', ') : 'no roles'}</em>
      </span>
      <Button size="sm" onClick={() => void auth.signoutRedirect()}>
        Log out
      </Button>
    </header>
  );
}
